module.exports = __webpack_public_path__ + "img/max3.d390f690.jpg";